import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from '../+services/auth.service';
import { ProjectService } from '../+services/projects/service';
import { ForgottPasswordChangeComponent } from '../pages/auth/forgott-password-change/forgott-password-change.component';
import { ForgottPasswordComponent } from '../pages/auth/forgott-password/forgott-password.component';
import { LoginComponent } from '../pages/auth/login/login.component';
import { RegistrationComponent } from '../pages/auth/registration/registration.component';
import { TwoFactorAuthComponent } from '../pages/auth/two-factor-auth/two-factor-auth.component';
import { MainContentComponent } from '../pages/main-content/main-content.component';
import { ProjectsComponent } from '../pages/projects/projects.component';
import { RegistrationWizardComponent } from '../pages/registration-wizard/registration-wizard.component';
import { ButtonComponent } from './common/button/button.component';
import { DecisionBadgeListComponent } from './common/decision-badge-list/decision-badge-list.component';
import { DetailsPageHeaderComponent } from './common/details-page-header/details-page-header.component';
import { BadgeCellRendererComponent } from './common/grid-table/badge-cell-renderer/badge-cell-renderer.component';
import { DecisionCellRendererComponent } from './common/grid-table/decision-cell-renderer/decision-cell-renderer.component';
import { DeleteCellRendererComponent } from './common/grid-table/delete-cell-renderer/delete-cell-renderer.component';
import { DownloadCellRendererComponent } from './common/grid-table/download-cell-renderer/download-cell-renderer.component';
import { GridTableComponent } from './common/grid-table/grid-table.component';
import { LinkCellRendererComponent } from './common/grid-table/link-cell-renderer/link-cell-renderer.component';
import { SwitchCellRendererComponent } from './common/grid-table/switch-cell-renderer/switch-cell-renderer.component';
import { TwoLineCellRendererComponent } from './common/grid-table/two-line-cell-renderer/two-line-cell-renderer.component';
import { ProjectCardComponent } from './common/project-card/project-card.component';
import { DropdownMenuComponent } from './dropdown-menu/dropdown-menu.component';
import { LegalPersonValidatedFormComponent } from './legal-person-validated-form/legal-person-validated-form.component';
import { MeetingAlertComponent } from './meeting-alert/meeting-alert.component';
import { NavbarHprizontalComponent } from './navbar/navbar-horizontal/navbar-horizontal.component';
import { NavbarVerticalComponent } from './navbar/navbar-vertical/navbar-vertical.component';
import { ProfileEditComponent } from './profile-edit/profile-edit.component';
import { RepresentationTypeDialogComponent } from './registration/representation-type-dialog/representation-type-dialog.component';
import { MultiSelectComponent } from './search/multi-select/multi-select.component';
import { WizardComponent } from './wizard/wizard.component';

@NgModule({
  declarations: [MainContentComponent, SwitchCellRendererComponent],
  imports: [
    NavbarHprizontalComponent,
    NavbarVerticalComponent,
    CommonModule,
    ProjectCardComponent,
    MultiSelectComponent,
    LoginComponent,
    TwoFactorAuthComponent,
    ForgottPasswordComponent,
    ForgottPasswordChangeComponent,
    RegistrationComponent,
    TranslatePipe,
    WizardComponent,
    RegistrationWizardComponent,
    RouterLink,
    RepresentationTypeDialogComponent,
    ProjectsComponent,
    GridTableComponent,
    LinkCellRendererComponent,
    DetailsPageHeaderComponent,
    ProfileEditComponent,
    ButtonComponent,
    DecisionBadgeListComponent,
    TwoLineCellRendererComponent,
    DownloadCellRendererComponent,
    DecisionCellRendererComponent,
    DeleteCellRendererComponent,
    DropdownMenuComponent,
    BadgeCellRendererComponent,
    LegalPersonValidatedFormComponent,
    MeetingAlertComponent,
  ],
  exports: [
    NavbarHprizontalComponent,
    NavbarVerticalComponent,
    MainContentComponent,
    ProjectsComponent,
    WizardComponent,
  ],
  providers: [AuthService, ProjectService],
})
export class ComponentsModule {}
